import checkIcon from './assets/check.svg'
import heroIllustration from './assets/hero-illustration.png'
import collectLeadsIllustration from './assets/tile-collect-leads.png'
import conferenceIllustration from './assets/tile-conference.jpg'
import corporateEventIllustration from './assets/tile-corporate-event.jpg'
import customLeadFormIllustration from './assets/tile-custom-lead-form.jpg'
import desktopIllustration from './assets/tile-desktop.jpg'
import educateParticipantsIllustration from './assets/tile-educate-participants.jpg'
import engageAudienceIllustration from './assets/tile-engage-audience.png'
import givePrizesIllustration from './assets/tile-give-prizes.png'
import inStoreIllustration from './assets/tile-in-store.jpg'
import instantWinIllustration from './assets/tile-instant-win.jpg'
import integrationCrmIllustration from './assets/tile-integration-crm.png'
import integrationCsvIllustration from './assets/tile-integration-csv.png'
import integrationCustomDomainIllustration from './assets/tile-integration-custom-domain.png'
import integrationEmbedIllustration from './assets/tile-integration-embed.png'
import integrationExternalAnalyticsIllustration from './assets/tile-integration-external-analytics.png'
import integrationWebhookIllustration from './assets/tile-integration-webhook.png'
import kioskIllustration from './assets/tile-kiosk.jpg'
import largeScreenIllustration from './assets/tile-large-screen.jpg'
import leadConsentIllustration from './assets/tile-lead-consent.jpg'
import leaderboardIllustration from './assets/tile-leaderboard.jpg'
import leadsAfterGameIllustration from './assets/tile-leads-after-game.jpg'
import leadsBeforeGameIllustration from './assets/tile-leads-before-game.jpg'
import memoryGameIllustration from './assets/tile-memory-game.jpg'
import nameEmailIllustration from './assets/tile-name-email.jpg'
import noParticipantDataIllustration from './assets/tile-no-participant-data.jpg'
import onlineEventIllustration from './assets/tile-online-event.jpg'
import participantPhonesIllustration from './assets/tile-participant-phones.jpg'
import participationContinuousFlowIllustration from './assets/tile-participation-continuous-flow.png'
import participationHostLedIllustration from './assets/tile-participation-host-led.png'
import participationIndividualIllustration from './assets/tile-participation-individual.jpg'
import participationPhonesIllustration from './assets/tile-participation-phones.png'
import participationTeamsIllustration from './assets/tile-participation-teams.png'
import participationWalkUpIllustration from './assets/tile-participation-walk-up.jpg'
import prizesDrawIllustration from './assets/tile-prizes-draw.jpg'
import prizesInstantIllustration from './assets/tile-prizes-instant.png'
import prizesLimitedIllustration from './assets/tile-prizes-limited.jpg'
import prizesNoneIllustration from './assets/tile-prizes-no-prizes.png'
import prizesPromoCodeIllustration from './assets/tile-prizes-promo-code.jpg'
import prizesWinnersIllustration from './assets/tile-prizes-winners.jpg'
import promoteProductIllustration from './assets/tile-promote-product.jpg'
import publicEventIllustration from './assets/tile-public-event.jpg'
import puzzleIllustration from './assets/tile-puzzle.jpg'
import quizIllustration from './assets/tile-quiz.jpg'
import scaleEventSeriesIllustration from './assets/tile-scale-event-series.png'
import scaleMultipleClientsIllustration from './assets/tile-scale-multiple-clients.png'
import scaleMultipleLocationsIllustration from './assets/tile-scale-multiple-locations.jpg'
import scaleMultipleScreensIllustration from './assets/tile-scale-multiple-screens.jpg'
import scaleOneEventIllustration from './assets/tile-scale-one-event.png'
import scaleOneScreenIllustration from './assets/tile-scale-one-screen.png'
import spinWheelIllustration from './assets/tile-spin-wheel.jpg'
import tabletIllustration from './assets/tile-tablet.jpg'
import teamEngagementIllustration from './assets/tile-team-engagement.jpg'
import touchscreenIllustration from './assets/tile-touchscreen.png'
import tradeShowIllustration from './assets/tile-trade-show.png'

export { checkIcon, heroIllustration }

export const EVENT_TILE_ILLUSTRATIONS = {
    venue_trade_show: tradeShowIllustration,
    venue_conference: conferenceIllustration,
    venue_in_store: inStoreIllustration,
    venue_corporate_event: corporateEventIllustration,
    venue_public_event: publicEventIllustration,
    venue_online_event: onlineEventIllustration,
    goal_engage_audience: engageAudienceIllustration,
    goal_collect_leads: collectLeadsIllustration,
    goal_prize_giveaway: givePrizesIllustration,
    goal_promote_product: promoteProductIllustration,
    goal_educate_audience: educateParticipantsIllustration,
    goal_team_engagement: teamEngagementIllustration,
    mechanic_spin_wheel: spinWheelIllustration,
    mechanic_quiz: quizIllustration,
    mechanic_memory: memoryGameIllustration,
    mechanic_instant_win: instantWinIllustration,
    mechanic_leaderboard: leaderboardIllustration,
    mechanic_puzzle: puzzleIllustration,
    participation_individual: participationIndividualIllustration,
    participation_walk_up: participationWalkUpIllustration,
    participation_host_led: participationHostLedIllustration,
    participation_participant_phones: participationPhonesIllustration,
    participation_team_game: participationTeamsIllustration,
    participation_continuous_flow: participationContinuousFlowIllustration,
    device_touchscreen: touchscreenIllustration,
    device_tablet: tabletIllustration,
    device_large_screen: largeScreenIllustration,
    device_kiosk: kioskIllustration,
    device_participant_phones: participantPhonesIllustration,
    device_desktop: desktopIllustration,
    leads_none: noParticipantDataIllustration,
    leads_basic_contact: nameEmailIllustration,
    leads_custom_form: customLeadFormIllustration,
    leads_before_game: leadsBeforeGameIllustration,
    leads_after_game: leadsAfterGameIllustration,
    leads_consent: leadConsentIllustration,
    rewards_none: prizesNoneIllustration,
    rewards_instant_prize: prizesInstantIllustration,
    rewards_prize_draw: prizesDrawIllustration,
    rewards_limited_inventory: prizesLimitedIllustration,
    rewards_promo_code: prizesPromoCodeIllustration,
    rewards_winner_log: prizesWinnersIllustration,
    scale_single_screen: scaleOneScreenIllustration,
    scale_multiple_screens: scaleMultipleScreensIllustration,
    scale_single_event: scaleOneEventIllustration,
    scale_event_series: scaleEventSeriesIllustration,
    scale_multiple_locations: scaleMultipleLocationsIllustration,
    scale_multiple_clients: scaleMultipleClientsIllustration,
    integration_csv: integrationCsvIllustration,
    integration_embed: integrationEmbedIllustration,
    integration_crm: integrationCrmIllustration,
    integration_webhook: integrationWebhookIllustration,
    integration_custom_domain: integrationCustomDomainIllustration,
    integration_external_analytics: integrationExternalAnalyticsIllustration,
}
